<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About The Author</h1>
<p>Sean Dennis Cashman worked as a historian for New York University Press, an editor for the Ford Foundation and a music and theatre journalist for the <em>New Haven Register.</em> He taught at the University of Manchester, New York University and Adelphi University on Long Island where he was dean of arts and sciences. His <em>America in the Gilded Age</em> is a classic.</p>
<p>In this novel, he draws from his varied life to create a vivid tapestry mixing history, fantasy and satire. Kings buried in Westminster Abbey rise on All Souls’ Eve. They entertain a New York family for a scary price.</p>
<br/>
<p> Other books by SDC include: </p>
<br/>
<p><em>America in the Gilded Age</em></p>
<br/>
<p><em>America in the Age of the Titans: The Progressive Era and World War I</em></p>
<br/>
<p><em>America Ascendant: From Theodore Roosevelt to FDR in the Century of American Power, 1901–1945</em></p>
<br/>
<p><em>War in Pieces 1: Ivan the Terrible from Tulsa</em></p>
<br/>
<p><em>War in Pieces 2: The Holly Wood Years of Ivan the Terrible</em></p>
<br/>
<p><em>Luke Reader, blind detective</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?43c63732